<div fxFlex="1 1 100%" fxLayout="row" class="add-staff-wrapper"    [ngClass]="{'modalWrapper': usedInsideApp }">
      <div fxLayout="column" fxFlex="1 1 100%" class="add-staff-content" 
      [ngClass]="{
      'errorPageUploadModal': usedInsideApp && renderUploadStaff === ADD_STAFF_PAGE_NUMBER.fileUploadPage
    }"
         >
    <ng-container *ngIf="renderUploadStaff !== ADD_STAFF_PAGE_NUMBER.fileUploadPage">
      <div *ngIf="!usedInsideApp" fxFlex="120px" fxFlex.lt-md="70px" fxLayout="row">
        <label class="header">Let’s add your staff</label>
      </div>

      <div fxLayout="row" fxFlex="15px" fxLayoutAlign="start end">
        <label class="sub-header">How would you like to add your staff?</label>
      </div>

      <div fxLayout="row" fxFlex="4px" fxLayoutAlign="start end">
        <mat-divider class="horizontal-divider"></mat-divider>
      </div>

      <div fxLayout="row" fxFlex="95px" fxFlex.lt-md="140px" fxLayoutAlign="start end">

        <mat-radio-group color="primary" class="radio-group">
          <mat-radio-button fxLayout.lt-md="column" value="manual" [checked]="addOrUploadStaff === 'manual'"
            (change)="getAddStaffType($event.value)" automation-id="button-add-staff-manual">
            <span fxLayout.lt-md="row" class="description">Add them Individually </span> <span fxLayout.lt-md="row"
              class="instruction">(Add your staff one at a
              time)</span>
          </mat-radio-button>
          <br><br>
          <mat-radio-button fxLayout.lt-md="column" value="upload" [checked]="addOrUploadStaff === 'upload'"
            (change)="getAddStaffType($event.value)" automation-id="button-add-staff-upload">
            <span fxLayout.lt-md="row" class="description">Upload a Spreadsheet </span> <span fxLayout.lt-md="row"
              class="instruction">(Add your staff with a file
              you upload)</span>
          </mat-radio-button>
        </mat-radio-group>

      </div>
      <div fxLayout="row" fxFlex="42px" fxFlex.lt-md="20px" fxLayoutAlign="start end">
        <mat-divider class="horizontal-divider"></mat-divider>
      </div>
    </ng-container>

    <div [ngClass]="{'staff-data': addOrUploadStaff === 'manual' }">
        <app-manual-add 
          *ngIf="addOrUploadStaff === 'manual' &&
           renderUploadStaff !== ADD_STAFF_PAGE_NUMBER.fileUploadPage" 
           (activeStaff)="getUpdatedData($event)" 
           (validState)="isValidState = $event"
           [shownInApp] = "usedInsideApp"
           [showAddAnother]="true">
        </app-manual-add>
        <app-add-staff-wrapper 
          *ngIf=" addOrUploadStaff === 'upload' && 
           renderUploadStaff !== ADD_STAFF_PAGE_NUMBER.fileUploadPage" 
          (file)="moveToUpload($event)">
        </app-add-staff-wrapper>
        <app-upload-staff 
        [usedInsideApp] = "usedInsideApp"
          *ngIf="renderUploadStaff === ADD_STAFF_PAGE_NUMBER.fileUploadPage" 
          (validState)="navigateToNextPage($event) "
          (addStaff)="goToAddStaffPage($event)"
            (file)="moveToUpload($event)">
        </app-upload-staff>
    </div>

    <div class="state-buttons" fxFlex="0 0 auto"   *ngIf="addOrUploadStaff === 'manual'" fxHide.gt-sm fxLayout="row">
      <app-schedule-creation-state-buttons  [ngClass]="{'position-bottom': usedInsideApp}" [hideBack]="usedInsideApp" [hideButtons]="addOrUploadStaff !== 'manual'" [hideSave]="!isChanged"
        (forwardStateChange)="forwardStateChange()" [validBackBtn]="true" [validNextBtn]="!!isValidState"
        fxFlex="0 0 100%" (saveButtonClicked)="callStaffAPI()">
      </app-schedule-creation-state-buttons>
    </div>

  </div>
</div>
    <app-schedule-creation-state-buttons   *ngIf="addOrUploadStaff === 'manual'"   [ngClass]="{'position-bottom': usedInsideApp}"  fxHide.lt-md [hideButtons]="addOrUploadStaff !== 'manual'" [hideBack]="usedInsideApp" [hideSave]="!isChanged || usedInsideApp"
      (forwardStateChange)="forwardStateChange()" [validBackBtn]="true" [validNextBtn]="!!isValidState"
      (saveButtonClicked)="callStaffAPI()">
    </app-schedule-creation-state-buttons>





<ng-template #loader>
  <div class="loader">
    <img fxFlex="0 1 70px" src="../../../../assets/images/loader.gif" height="70" width="70" />
  </div>
</ng-template>